import axios from './axios'
// _makeRequest---------------------------------------------------------------------------------------
const _makeRequest = (requestConfig) => {
  return new Promise((resolve, reject) => {

    axios(requestConfig)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        const error = {
          message: err.response ? err.response.data : 'Unknown error try it later',
          code : err.response ? err.response.status || null : null
        };
        reject(error);
      })
  })
};
const getDevice = ({token, deviceID}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'get',
      url: `/devices/${deviceID}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}
const getDeviceConfig = ({token, deviceID}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'get',
      url: `/devices/${deviceID}/configuration`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}
const getDeviceAlarm = ({token, deviceID}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'get',
      url: `/devices/${deviceID}/alarm-configuration`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}
const getDeviceHistory = ({token, deviceID, date, format}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'get',
      url: `/devices/${deviceID}/historical?date=${date}&out=${format}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}
const getAlarmHistory = ({token, deviceID, limit, page, date, format}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'get',
      url: `/devices/${deviceID}/historical-alarm?limit=${limit}&page=${page}&date=${date}&out=${format}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}

const updateAlarmConfig = ({token, deviceID, data}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'put',
      url: `/devices/${deviceID}/alarm-configuration`,
      data,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}

const updateDeviceConfig = ({token, deviceID, data}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'patch',
      url: `/devices/${deviceID}/configuration`,
      data,
      headers: {
        'Authorization': `Bearer ${token}`
      }
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}

const linkDevice = ({token, userID, device}) => {
    return new Promise((resolve, reject) => {
      const requestConfig = {
        method: 'post',
        url: `/users/${userID}/linkDevice`,
        headers: {
          'Authorization': `Bearer ${token}`
        },
        data: {
            deviceImeiID: device.deviceID,
            alias: device.alias,
            password: device.password
        }
        
      }
      _makeRequest(requestConfig)
        .then(result => {
          resolve(result)
        })
        .catch(err => {
            reject(err.message);
        })
    })
  }
const unlinkDevice = ({token, userID, deviceID}) => {
    return new Promise((resolve, reject) => {
        const requestConfig = {
        method: 'post',
        url: `/users/${userID}/unlinkDevice`,
        headers: {
            'Authorization': `Bearer ${token}`
        },
        data: {
            deviceID: deviceID,
        }
        
        }
        _makeRequest(requestConfig)
        .then(result => {
            resolve(result)
        })
        .catch(err => {
            reject(err);
        })
    })
}

const updateDevice = ({token, deviceID, data}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'patch',
      url: `/devices/${deviceID}`,
      headers: {
        'Authorization': `Bearer ${token}`
      },
      data: data
      
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err.message);
      })
  })
}

export default {
  getDevice,
  getDeviceConfig,
  getDeviceAlarm,
  getDeviceHistory,
  getAlarmHistory,
  updateAlarmConfig,
  updateDeviceConfig,
  linkDevice,
  unlinkDevice,
  updateDevice
}
  